'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var flexContainer = exports.flexContainer = {
    display: 'flex',
    flex: '1 0 0',
    flexDirection: 'column'
};

var scrollContainer = exports.scrollContainer = {
    flex: '1 0 0',
    overflow: 'auto'
};
//# sourceMappingURL=layout.js.map